/* eslint-disable no-undef */
let countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/bg.json"));
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/sq.json"));
/* eslint-enable no-undef */
import {$$} from '../helpers/localization'

export function getcountry_labelName(countryCode, language) {
    if (!language) {
        language = 'EN';
    }
    return countries.getName(language, countryCode)
}

export function countryOptions(language, includeAll = false) {
    if (!language) {
        language = 'EN';
    }
    let options = Object.entries(countries.getNames(language)).map(([key, value]) => {
        return {value: key.toLowerCase(), text: value}
    });

    options = options.sort((a, b) => {
        if (a.value.toLowerCase() === 'bg') return -1;
        if (b.value.toLowerCase() === 'bg') return 1;

        if (a.value.toLowerCase() === 'gb') return -1;
        if (b.value.toLowerCase() === 'gb') return 1;

        if (a.value.toLowerCase() === 'us') return -1;
        if (b.value.toLowerCase() === 'us') return 1;

        return a.text.localeCompare(b.text)
    });

    if (includeAll) {
        options.unshift({value: "ALL", text: $$("all_label")});
    }
    return options;
}